import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import * as yup from "yup";

import { Route, useRouter, useSearchParams } from "@sol/routing";

import GDPRDisclaimer from "../components/GDPRDisclaimer";
import { configure } from "../store/gdpr/actions";
import { IGDPRSettings } from "../store/gdpr/types";

const querySchema = yup.object().shape({
    redirect: yup.string(),
});

const GDPRPage = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const { redirect } = querySchema.cast(useSearchParams());

    const handleSave = useCallback(
        (values: IGDPRSettings) => {
            dispatch(configure(values));

            if (redirect) {
                router.push({ route: redirect as Route });
            } else if (!router.canGoBack) {
                router.push({ route: Route.HOME });
            } else {
                router.back();
            }
        },
        [dispatch, router, redirect],
    );

    return <GDPRDisclaimer onSave={handleSave}></GDPRDisclaimer>;
};

export default GDPRPage;
